const FontWeights = {
  headerWeight: 500,
  textWeight: 400,
  subtextWeight: 300,
}

export default FontWeights
